import { createTypedHooks } from "@poscon/shared-frontend";
import type { RootState, RootDispatch } from "~redux/store";

export const { useRootDispatch, useRootSelector } = createTypedHooks<RootState, RootDispatch>();
